export default "__VITE_ASSET__24492ba1__"